import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';


function Blog() {
    const API_URL = process.env.REACT_APP_API_URL;
    const [blogData, setBlogData] = useState(null);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const blog = location.state;
    const { id } = useParams(location)
    const navigate = useNavigate();


    useEffect(() => {
        if (!blog) {
            fetchBlog(id);
        }
        else {
            setBlogData(blog)
        }
    }, [id]);

    const fetchBlog = async (id) => {
        try {
            const response = await fetch(`${API_URL}/blog/getBlog/?id=${id}`)

            const result = await response.json()

            if (result.statusCode == 200) {
                setBlogData(result.data)
                setLoading(false)
            }
            else {
                setBlogData(null)
                setLoading(false)
            }
        }
        catch (error) {
        }
    }

    const convertDateTime = (created) => {
        if (created != null) {
            const dateObject = new Date(created);
            const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
            const datePart = dateObject.toLocaleDateString('en-GB', options);
            return `${datePart}`;
        }
    }

    if (loading) return <div>Loading...</div>;

    if (!blogData) return <div>Блогот не е пронајден</div>;


    return (
        <div className="max-w-4xl mx-auto p-6 bg-gray-200">
            <Link to ='/blogList'>
                <button className='btn btn-third btn-outline btn-sm'>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    Оди назад
                </button>
            </Link>

            <h1 className="text-4xl text-center font-bold mb-4">{blogData.title}</h1>
            <img
                src={blogData.imageUrl}
                alt={blogData.title}
                className="mx-auto w-[80%] h-auto max-h-[600px] object-contain mb-6"
            />
            <p className='text-end'>{convertDateTime(blogData.created)}</p>
            <div className="divider mt-1"></div>

            <p className="text-lg mb-4">{blogData.content}</p>

            {(blogData.subtitle || blogData.subContent || blogData.subImageUrl) && (
                <div>

                    <h3 className='text-2xl font-semibold'>{blogData.subtitle}</h3>
                    <img
                        src={blogData.subImageUrl}
                        alt={blogData.subtitle}
                        className="mx-auto w-[80%] h-auto  max-h-[400px] object-contain mb-6"
                    />
                    <p className="text-lg mb-4">{blogData.subContent}2222</p>
                </div>
            )}
            {(blogData.subtitle1 || blogData.subContent1 || blogData.subImageUrl1) && (
                <div>

                    <h3 className='text-2xl font-semibold'>{blogData.subtitle1}</h3>
                    {blogData.subImageUrl1 && <img
                        src={blogData.subImageUrl1}
                        alt={blogData.subtitle1}
                        className="mx-auto w-[80%] h-auto max-h-[400px] object-contain mb-6"
                    />}
                    <p className="text-lg mb-4">{blogData.subContent1}</p>
                </div>
            )}
            {(blogData.subtitle2 || blogData.subContent2 || blogData.subImageUrl2) && (
                <div>

                    <h3 className='text-2xl font-semibold'>{blogData.subtitle2}</h3>
                    <img
                        src={blogData.subImageUrl2}
                        alt={blogData.subtitle2}
                        className="mx-auto w-[80%] h-auto max-h-[400px] object-contain mb-6"
                    />
                    <p className="text-lg mb-4">{blogData.subContent2}</p>
                </div>
            )}
        </div>
    )
}

export default Blog
